import { CircularProgress } from '@mui/material';
import * as styles from './styles.css';

const LoadingSpinner = () => {
  return (
    <div className={styles.loading_spinner}>
      <CircularProgress />
    </div>
  );
};

export default LoadingSpinner;
